import { FC, useContext, lazy, Suspense } from 'react'
import './App.css'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthContext } from './store/LoginAuthContext'

const HomePage = lazy(() => import('./pages/HomePage'))
const PageContent = lazy(() => import('./pages/landingPage/LandingPage'))
const Reports = lazy(() => import('./composites/easyToBorrow/EasyToBorrow'))
const ReviewPage = lazy(() => import('./pages/reviewLocatePage/ReviewPage'))
const InventoryPage = lazy(
  () => import('./composites/inventoryPage/InventoryPage')
)
const LogOnPage = lazy(() => import('./pages/logOnPage/LogOnPage'))

const App: FC = () => {
  const authContext = useContext(AuthContext)
  return (
    <AuthContext.Provider value={authContext}>
      <Suspense>
        <Routes>
          <Route element={<HomePage />}>
            <Route path="/submit" element={<PageContent />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/reviewlocate" element={<ReviewPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
          </Route>
          <Route path="/login" element={<LogOnPage />} />
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Suspense>
    </AuthContext.Provider>
  )
}

export default App
